// extracted by mini-css-extract-plugin
export default {"container":"Mobile_container__OvKpn","logo":"Mobile_logo__3T1Vv"};